import { translate } from 'react-polyglot';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function UnknownControl({
  field,
  t
}) {
  return _jsx("div", {
    children: t('editor.editorWidgets.unknownControl.noControl', {
      widget: field.get('widget')
    })
  });
}
UnknownControl.propTypes = {
  field: ImmutablePropTypes.map,
  t: PropTypes.func.isRequired
};
export default translate()(UnknownControl);